
import React, { useCallback, useMemo } from 'react';
import SeismicPlayer from '@seismic/universal-player';
import { PlayerEventHandler } from '../commonUtil/playerEvent';
import { getLang } from '../commonUtil/i18n';
import { withLinkStore } from '../app/reducers';
import { isFirestorm } from '../commonUtil/util';
import { UniversalPlayerMode } from '../commonUtil/constants';

const Player = (props) => {
    const { linkDispatch } = props;
    const { selectedManifest, linkBasicInfo, isOnlyFunctionalCookies } = props.linkStore;
    // show the “present” mode if Firestorm is available
    const mode = isFirestorm(selectedManifest) ? UniversalPlayerMode.PRESENT : UniversalPlayerMode.READ;

    const playerHandler = useCallback((e) => {
        const args = { isExpired: linkBasicInfo.isExpired, dispatch: linkDispatch, isOnlyFunctionalCookies };
        PlayerEventHandler(e, props.displayFooter, args);
    }, [isOnlyFunctionalCookies]);

    const result = useMemo(() => {
        const lang = getLang();
        return (<div className="seismic-universal-player-container" aria-live="polite">
            <SeismicPlayer
                config={selectedManifest}
                lang={lang}
                mode={mode}
                onPlayerEvent={playerHandler} />
        </div>);
    }, [selectedManifest]);

    return result;
};

export default withLinkStore(Player);
